module.exports = __webpack_public_path__ + "static/media/yo.8e6d7645.png";